import './ArrowButton.css';

import React from 'react';
import Icon from '@vtblife/uikit-icons';

import classname from '@search/classname/src';

const cn = classname.bind(null, 'ArrowButton');

export type ArrowDirection = 'left' | 'right';

export function ArrowButton({
    onClick,
    size = 'm',
    dataTest,
    direction,
    variant,
    disabled,
    isDisabledToHide
}: {
    size?: 'm' | 's';
    disabled?: boolean;
    variant?: 'alt';
    direction: ArrowDirection;
    onClick?(direction: ArrowDirection): void;
    dataTest?: string;
    isDisabledToHide?: boolean;
}) {
    return (
        <button
            disabled={disabled}
            className={cn(null, { variant, size, disabled, isDisabledToHide })}
            onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                onClick?.(direction);
            }}
            data-test={dataTest}
        >
            <Icon
                name={direction === 'right' ? 'chevron-right' : 'chevron-left'}
                size='m'
            />
        </button>
    );
}
